<template>
    <a-card hoverable class="login-box">
        <div slot="title">
            <img src="/images/logo.png" style="width: 70%;" />
        </div>
        <div slot="extra" v-if="ID_LOGIN">
            <a-button type="link" @click="doIdLogin('root')">
                平台
            </a-button>
            <a-button type="link" @click="doIdLogin('JTIf0mJG')">
                杰睿注意力
            </a-button>
            <a-button type="link" @click="doIdLogin('x2d2y3D0')">
                机构
            </a-button>
            <a-button type="link" @click="doIdLogin('2405231911')">
                机构员工
            </a-button>
        </div>
        <template slot="actions">
            <a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备17004933号-5</a>
        </template>
        <div>
            <div style="border:1px dashed grey; width: 300px; margin:0 auto;padding: 10px;">
                <div id="qr" class="qr"></div>
            </div>
            <div class="info">{{ info }}</div>
        </div>
    </a-card>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
    name: 'Login',
    data() {
        return {
            loading: false,
            timer: undefined,
            qrCode: undefined,
            info: '请打开 [微信] 扫描二维码登录',
            tag: '',
            time: 0,
            ID_LOGIN: false
        }
    },
    mounted() {
        this.doLoad()
        this.timer = setInterval(this.doQuery, 1000)
        this.ID_LOGIN = process.env.VUE_APP_RUN_MODE !== 'prod'
    },
    beforeDestroy() {
        if (this.timer !== undefined) {
            clearInterval(this.timer)
        }
    },
    methods: {
        doIdLogin(id) {
            this.$http
                .post('/dev/user/login', {
                    uid: id
                })
                .then(result => {
                    if (result.code != 0) {
                        return
                    }
                    if (this.timer !== undefined) {
                        clearInterval(this.timer)
                    }
                    this.$store.commit('signin', result.data.user)
                    this.$router.replace('/')
                })
        },
        doLoad() {
            this.loading = true
            this.info = '请打开 [微信] 扫描二维码登录'
            this.$http
                .get('/ums/user/login/info', {
                    params: {
                        type: 'Ops',
                        _: new Date().getTime() / 1000 / 60
                    }
                })
                .then(result => {
                    this.loading = false
                    if (result.code != 0) {
                        return
                    }
                    this.tag = result.data.tag
                    this.time = result.data.time
                    if (!this.qrCode) {
                        this.qrCode = new QRCode('qr', {
                            text: result.data.url,
                            width: 280,
                            height: 280,
                            colorDark: '#000000',
                            colorLight: '#ffffff',
                            correctLevel: QRCode.CorrectLevel.H
                        })
                    } else {
                        this.qrCode.clear()
                        this.qrCode.makeCode(result.data.url)
                    }
                })
        },
        doQuery() {
            if (!this.tag) {
                return
            }
            let now = new Date().getTime()
            // if (now > this.time) {
            //     this.doLoad()
            //     return
            // }
            this.$http
                .get('/ums/user/login/state', {
                    loading: { flag: false },
                    params: {
                        _: now,
                        tag: this.tag
                    }
                })
                .then(result => {
                    if (result.code != 0) {
                        return
                    }
                    if (result.data.flg === 'Pass') {
                        if (this.timer !== undefined) {
                            clearInterval(this.timer)
                        }
                        this.$store.commit('signin', result.data.user)
                        this.$router.replace('/')
                    } else if (result.data.flg === 'Scan') {
                        this.info = '已扫码，请在微信端确认登录'
                    } else if (result.data.flg === 'Expire' || result.data.flg === 'Error') {
                        this.doLoad()
                    }
                })
        }
    }
}
</script>

<style scoped>
.login-box {
    width: 500px;
    margin: auto;
    text-align: center;
    margin-top: 10vh;
}
.qr {
    display: inline-block;
}
.qr img {
    width: 280px;
    height: 280px;
    background-color: #fff;
}
.info {
    margin-top: 1em;
    color: grey;
}
</style>
